import { useNavigate, useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Brain, Clock, Repeat, ScrollText, Wrench, ShieldAlert, FileSearch, Activity, LineChart } from "lucide-react";
import MemoryTabRecente from "@/components/memory/MemoryTabRecente";
import MemoryTabPadroes from "@/components/memory/MemoryTabPadroes";
import MemoryTabOficial from "@/components/memory/MemoryTabOficial";
import MemoryTabHabitos from "@/components/memory/MemoryTabHabitos";
import MemoryTabHipocampo from "@/components/memory/MemoryTabHipocampo";
import MemoryAudit from "@/pages/MemoryAudit";
import MemoriaQuarentena from "@/pages/MemoriaQuarentena";
import MemoryHealth from "@/pages/MemoryHealth";
import MemoryStabilizationDashboard from "@/components/memory/MemoryStabilizationDashboard";

type TabKey = "hipocampo" | "recente" | "padroes" | "oficial" | "habitos" | "auditoria" | "quarentena" | "health" | "estabilizacao";
const VALID: TabKey[] = ["hipocampo", "recente", "padroes", "oficial", "habitos", "auditoria", "quarentena", "health", "estabilizacao"];

export default function MemoryHub() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const raw = (params.get("tab") || "hipocampo") as TabKey;
  const tab: TabKey = VALID.includes(raw) ? raw : "hipocampo";
  const setTab = (v: string) => navigate(`/memory?tab=${v}`, { replace: true });

  return (
    <div className="container mx-auto px-4 py-4 max-w-7xl">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Memória</h1>
        <p className="text-sm text-muted-foreground">
          O que a IA lembra, agrupado por como ela usa.
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="grid w-full max-w-6xl grid-cols-9">
          <TabsTrigger value="hipocampo" className="gap-2"><Brain className="w-4 h-4" />Hipocampo</TabsTrigger>
          <TabsTrigger value="recente" className="gap-2"><Clock className="w-4 h-4" />Recente</TabsTrigger>
          <TabsTrigger value="padroes" className="gap-2"><Repeat className="w-4 h-4" />Padrões</TabsTrigger>
          <TabsTrigger value="oficial" className="gap-2"><ScrollText className="w-4 h-4" />Oficial</TabsTrigger>
          <TabsTrigger value="habitos" className="gap-2"><Wrench className="w-4 h-4" />Hábitos</TabsTrigger>
          <TabsTrigger value="auditoria" className="gap-2"><FileSearch className="w-4 h-4" />Auditoria</TabsTrigger>
          <TabsTrigger value="quarentena" className="gap-2"><ShieldAlert className="w-4 h-4" />Quarentena</TabsTrigger>
          <TabsTrigger value="health" className="gap-2"><Activity className="w-4 h-4" />Saúde</TabsTrigger>
          <TabsTrigger value="estabilizacao" className="gap-2"><LineChart className="w-4 h-4" />Estabilização</TabsTrigger>
        </TabsList>

        <TabsContent value="hipocampo" className="mt-4"><MemoryTabHipocampo /></TabsContent>
        <TabsContent value="recente" className="mt-4"><MemoryTabRecente /></TabsContent>
        <TabsContent value="padroes" className="mt-4"><MemoryTabPadroes /></TabsContent>
        <TabsContent value="oficial" className="mt-4"><MemoryTabOficial /></TabsContent>
        <TabsContent value="habitos" className="mt-4"><MemoryTabHabitos /></TabsContent>
        <TabsContent value="auditoria" className="mt-4"><MemoryAudit /></TabsContent>
        <TabsContent value="quarentena" className="mt-4"><MemoriaQuarentena /></TabsContent>
        <TabsContent value="health" className="mt-4"><MemoryHealth /></TabsContent>
        <TabsContent value="estabilizacao" className="mt-4"><MemoryStabilizationDashboard /></TabsContent>
      </Tabs>
    </div>
  );
}
